import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import CreateBloc from './Blocs/CreateBloc'

class IndexView extends Component {

    source
    createBloc = new CreateBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            parentOption: [],
            parentFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'menu_id',
                    order: 'asc' 
                }
            }
        }
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    loadOptions = async () => {
        let offset = (this.state.parentFilter.page_number-1)*this.state.parentFilter.page_size
        const query = {
            search: this.state.parentFilter.filter_value,
            limit: this.state.parentFilter.page_size,
            offset: offset,
            order: this.state.parentFilter.sort_order.column,
            sort: this.state.parentFilter.sort_order.order,
            status: 1
        }
        this.createBloc.fetchParentList(query, this.source.token)
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.parentFilter.filter_value = value

        this.timer = setTimeout(() => this.loadOptions(), 800);
    }


    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadOptions()
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.setTokenAPI()

        this.createBloc.parentListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                        const res = result.data.response
                        this.setState({ parentOption: res.result })
                    break
                case apiResponse.ERROR:
                        const response = result.data.response
                        // this.setState({ options: [] })
                        // console.log('cek ERROR ', result)
                    break
                default:
                    break
            }
        })
        
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.parentListChannel?.unsubscribe()
        this.createBloc.createChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Menu Form</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Keterangan menu-menu. Lorem ipsum dolor sit amet...
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldParentID"
                                                className="col-md-3 col-form-label"
                                            >
                                                Parent ID
                                            </label>
                                            <Col md="9">
                                                <Select 
                                                    name="parent_id"
                                                    placeholder="Parent ID..."
                                                    options={this.state.parentOption}
                                                    optionLabel="menu_name"
                                                    optionValue="menu_id"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldName"
                                                className="col-md-3 col-form-label"
                                            >
                                                Nama Menu
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="name"
                                                    placeholder="Nama Menu..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Menu"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="fieldName"
                                                />  
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldUrl"
                                                className="col-md-3 col-form-label"
                                            >
                                                Url Menu
                                            </label>
                                            <Col md="9">
                                                <AvField 
                                                    name="url"
                                                    placeholder="Url Menu... (Default: #)"
                                                    type="text"
                                                    errorMessage="Masukkan Url Menu"
                                                    className="form-control"
                                                    id="fieldUrl"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldIcon"
                                                className="col-md-3 col-form-label"
                                            >
                                                Ikon Menu
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="icon"
                                                    placeholder="Icon Menu..."
                                                    type="text"
                                                    errorMessage="Masukkan Ikon Menu"
                                                    className="form-control"
                                                    id="fieldIcon"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fieldSort"
                                                className="col-md-3 col-form-label"
                                            >
                                                Urutan
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="sort"
                                                    placeholder="Sort Menu..."
                                                    type="number"
                                                    errorMessage="Masukkan Urutan Menu"
                                                    className="form-control"
                                                    id="fieldSort"
                                                />
                                            </Col>
                                        </Row>
                                        <Button color="primary" style={{ float: 'right' }} type="submit">
                                            Submit form
                                        </Button>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/setting/menu.html'/>
                : null }
            </Fragment>
        )
    }
}

export default IndexView